import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is logged in from localStorage
    const savedUser = localStorage.getItem('yalla_user');
    const savedToken = localStorage.getItem('yalla_token');
    
    if (savedUser && savedToken) {
      setUser(JSON.parse(savedUser));
    } else {
      // Clear incomplete auth data
      localStorage.removeItem('yalla_user');
      localStorage.removeItem('yalla_token');
    }
    setLoading(false);
  }, []);

  const login = (authData) => {
    // authData contains { user, access_token, token_type }
    const userData = authData.user || authData;
    const token = authData.access_token;
    
    setUser(userData);
    localStorage.setItem('yalla_user', JSON.stringify(userData));
    
    if (token) {
      localStorage.setItem('yalla_token', token);
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('yalla_user');
    localStorage.removeItem('yalla_token');
  };

  const value = {
    user,
    login,
    logout,
    loading,
    isAuthenticated: !!user
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
